import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, TransitionGroup as _TransitionGroup, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font--small" }, "(Test)Mock data", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-left font--small" }, " Jeg kender ikke min nummerplade ", -1)
const _hoisted_3 = {
  key: "carInfoBox",
  class: "highlights fill mb-4"
}
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "input--searching--no--data"
}
const _hoisted_7 = { key: "kmMile" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  key: "kmForbrug",
  class: "input__label",
  textContent: 'Årlig km-forbrug'
}, null, -1)
const _hoisted_9 = { class: "button-container text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkboxComponent = _resolveComponent("checkboxComponent")!
  const _component_inputFieldComponent = _resolveComponent("inputFieldComponent")!
  const _component_CarSearchComponent = _resolveComponent("CarSearchComponent")!
  const _component_SelectModalComponent = _resolveComponent("SelectModalComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.isDevelop)
      ? (_openBlock(), _createBlock(_component_checkboxComponent, {
          key: _ctx.updateSearchBrandModel,
          id: "mockData",
          name: "mockData",
          preSelect: _ctx.cms.mockData,
          inputValue: _ctx.cms.mockData + '',
          class: "pb-4 box--small",
          onCheckboxComponent: _ctx.checkboxEventMock
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["preSelect", "inputValue", "onCheckboxComponent"]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_component_inputFieldComponent, {
      class: "pb-3 text-left",
      key: _ctx.updateLicenseplate,
      id: "licenseplate",
      name: "licenseplate",
      placeholder: 'F.eks. GG43245',
      label: "Nummerplade",
      validateOnLoad: !_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.carInfo.searchBrandModel,
      innerData: _ctx.model.carInfo,
      required: true,
      visibleError: !_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.carInfo.searchBrandModel,
      inputClassOverride: _ctx.model.carInfo.searchBrandModel ? '' : _ctx.inputClassOverride,
      onInputChanged: _ctx.licenseplateChanged,
      onInputFocus: _ctx.licenseplateChanged
    }, null, 8, ["placeholder", "validateOnLoad", "innerData", "visibleError", "inputClassOverride", "onInputChanged", "onInputFocus"])),
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        (_ctx.model.carInfo.searchBrandModel)
          ? (_openBlock(), _createBlock(_component_CarSearchComponent, {
              key: "updateCarModel",
              defaultValue: _ctx.model.carInfo.displayText,
              label: "Mærke, model o.s.v.",
              isValid: _ctx.model.carInfo.variantId !== undefined,
              isBrandModelSelected: _ctx.model.carInfo.isBrandModelSelected,
              visibleError: !_ctx.model.pristineStep.get(_ctx.card.name) && _ctx.model.carInfo.searchBrandModel,
              onCarSearchFocus: _ctx.resetCar,
              onCarSearch: _ctx.carSelected,
              onCarSearchProblem: _ctx.carSearchProblem,
              onCarSearchError: _ctx.carSearchError
            }, null, 8, ["defaultValue", "isValid", "isBrandModelSelected", "visibleError", "onCarSearchFocus", "onCarSearch", "onCarSearchProblem", "onCarSearchError"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          key: "spacer",
          class: _normalizeClass([{ 'pb-3': _ctx.model.carInfo.searchBrandModel }])
        }, null, 2),
        (_openBlock(), _createBlock(_component_checkboxComponent, {
          key: _ctx.updateSearchBrandModel,
          id: "searchBrandModel",
          name: "searchBrandModel",
          preSelect: _ctx.model.carInfo.searchBrandModel,
          inputValue: 'searchBrandModels',
          class: "pb-4 box--small",
          onCheckboxComponent: _ctx.checkboxEvent
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["preSelect", "onCheckboxComponent"])),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.model.carInfo.displayText)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  innerHTML: _ctx.model.carInfo.displayText
                }, null, 8, _hoisted_5))
              : (_ctx.showLicensePlateStatus)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Ingen bil matcher din søgning"))
                : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, _ctx.showCarInfoBox]
        ]),
        (_ctx.model.carInfo.displayText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _hoisted_8,
              _createVNode(_component_SelectModalComponent, {
                key: "mileage",
                id: "yearlyMileage",
                name: "yearlyMileage",
                preSelect: _ctx.model.carInfo.yearlyMileage,
                innerData: _ctx.cms.kmForbrug,
                selected: _ctx.model.carInfo.yearlyMileage !== undefined,
                placeholder: "Vælg årlig km-forbrug",
                visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
                errorMsgOverride: "Du skal vælge dit årlige km-forbrug",
                "onSelectModalComponent:selected": _ctx.selectYearlyMilage
              }, null, 8, ["preSelect", "innerData", "selected", "visibleError", "onSelectModalComponent:selected"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_ButtonTapComponent, {
        class: _normalizeClass([_ctx.card.buttonStyle, 'mt-3', { 'btn-disabled': !_ctx.isValid }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextStep())),
        "data-gtm": _ctx.cms.dataGtm,
        "data-gtm-click-text": _ctx.card.routePath
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.card.linkText), 1)
        ]),
        _: 1
      }, 8, ["class", "data-gtm", "data-gtm-click-text"])
    ])
  ]))
}